import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http'
import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  Inject,
  OnDestroy,
  ElementRef
} from '@angular/core'
import * as XLSX from 'xlsx'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry
} from 'ngx-file-drop'
import { environment } from 'src/environments/environment'
import Swal from 'sweetalert2'
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog'
import { SearchTableViewProcessordersService } from 'src/app/_services/search-table-view-processorders.service'
import { merge, Observable, of as observableOf } from 'rxjs'
import { catchError, filter, map, startWith, switchMap } from 'rxjs/operators'
import {
  DialogData,
  Lector,
  ResponseContact,
  ResponseFilesUrl,
  ResponseInventoryAvailable,
  ResponseInventoryAvailableNew,
  ResponseInventoryAvailableNew2,
  ResponseListPallets,
  ResponseUSer,
  ResponseViewProcessordersTable,
  ResponseViewProcessordersTableExportData
} from 'src/app/_models'
import { SearchTableOrderItemsService } from 'src/app/_services/search-table-order-items.service'
import { ResponseOrderItemsTable } from 'src/app/_models/order-items'
import { ResponseOrderChargerTable } from 'src/app/_models/order-charger'
import { SearchTableOrderChargerService } from 'src/app/_services/search-table-order-charger.service'
import { SearchTableSearchOrdersService } from 'src/app/_services/search-table-search-orders.service'
import { ResponseSearchOrdersTable } from 'src/app/_models/search-orders'
import { NavigationEnd, Router } from '@angular/router'
import {
  AuthenticationService,
  ViewInventotyAvailableService
} from 'src/app/_services'
import { NgxSpinnerService } from 'ngx-spinner'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { CodeBarScannerComponent } from '../modal/code-bar-scanner/code-bar-scanner.component'
import { BottomSheetOverviewReceivingPDF } from '../shipping/shipping.component'
import { formatDate } from '@angular/common'
import {
  Client,
  RequestPalceOrderEstatusDescripcion
} from 'src/app/_models/apiWerehouse'
import { MatSelect } from '@angular/material/select'
import { PdfBillOfLadingComponent } from '../modal/pdf-bill-of-lading/pdf-bill-of-lading.component'
import { ExportShippingProductsComponent } from '../modal/export-shipping-products/export-shipping-products.component'
import { ImportShippingFaseOneComponent } from '../modal/import-shipping-fase-one/import-shipping-fase-one.component'

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit, AfterViewInit, OnDestroy{
	ResponseViewProcessordersTableExportData: ResponseViewProcessordersTableExportData[]
	arrayDescripionRouting = []
	RequestPalceO: RequestPalceOrderEstatusDescripcion
	serviceWms: Client
	arrayfiles: ResponseFilesUrl[]
	listfile: ResponseFilesUrl
	CarrirsSearch = []
	// NOTE: variables
  
	//#region variables
	@ViewChild(MatPaginator) paginatorInven: MatPaginator
	@ViewChild(MatSort) sortInven: MatSort
	idDocumentUpload = 0
	datosLector: Lector // !!!: alert variable utilizada para el uso del lector de codigos de barra
	DefaultFechaFin = new FormControl(new Date(new Date().getTime() + 3888000000))
	DefaultFechaInicio = new FormControl(
	  new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000)
	)
	mySubscription: any
	currentUser: ResponseUSer
	cancelFile = true
	tab1 = false
	tab2 = false
	tab3 = true
	tab4 = true
  
	filterstatus: any
	filterCustomer: any
	SelectCostumerView = ''
	SelectCostumerSO = ''
	indexTabs = new FormControl(0)
	displayedColumnsInve: string[] = [
		'palletCount',
		'itemNumber',
		'description',
		'type_pallet',
		'totalPieces',
		'combinedTotal',
		'available'
	  ]
	displayedColumnsViewProcessorders: string[] = [
	  'options',
	  'id',
	  'PONumber',
	  'RefNumber',
	  'ShipDate',
	  'CancelShipDate',
	  'Confirmation',
	  'Comments',
	  'Notes',
	  'orderStatus',
	  'DateCreated',
	  'charges',
	  'StatusDescription',
	  'Routing',
	  'Billed',
	  'AllChargesAdded'
	]
	displayedColumnsSearch0rders: string[] = [
	  'options',
	  'id',
	  'PONumber',
	  'RefNumber',
	  'ShipDate',
	  'CancelShipDate',
	  'Confirmation',
	  'Comments',
	  'Notes',
	  'orderStatus',
	  'DateCreated',
	  'charges',
	  'StatusDescription',
	  'Routing',
	  'Billed',
	  'AllChargesAdded'
	]
	SearchDatabase: SearchTableViewProcessordersService | null
	data: ResponseViewProcessordersTable[] = []
	dataSourceSearch: MatTableDataSource<ResponseViewProcessordersTable>
	SearchDatabaseSO: SearchTableSearchOrdersService | null
	SearchDatabaseSO2: SearchTableSearchOrdersService | null
	dataSO: ResponseViewProcessordersTable[] = []
	dataSourceSearchSO: MatTableDataSource<ResponseViewProcessordersTable>
	@ViewChild('TableViewProcessordersPaginator')
	TableViewProcessordersPaginator: MatPaginator
	@ViewChild('TableViewProcessordersSort') TableViewProcessordersSort: MatSort
	@ViewChild('TableSearchSort') TableSearchSort: MatSort
	@ViewChild('TableSearchPaginator')
	TableSearchPaginator: MatPaginator
	resultsLength = 0
	isLoadingResults = true
	isRateLimitReached = false
	searchTable = false
	selected = 'option2'
	selected2 = 'option2'
	selected3 = 'option2'
	resultsLengthView = 0
	isLoadingResultsView = true
	isRateLimitReachedView = false
	searchTableView = false
	Company: string
	Address: string
	Address1: string
	City: string
	State: string
	Zip: string
	Phone: string
	Fax: String
	Cname: String
	Cphone: String
	Cemail: String
	Account: String
	ArrayDataTypeDocument = []
	PlaceOrderCustomer = []
	PlaceOrderCustomer2 = []
	PlaceOrderCustomer3 = []
	PlaceOrderCustomer4 = []
	respEditOrder: any
	respValidarOrder: any
	respCancelar: any
	PlaceOrderStatusDescripcion = []
	PlaceOrder = []
	DataFormulario: DialogData
	isLDT = false
	picker1 = (d: Date | null): boolean => {
	  const day = (d || new Date()).getDay()
	  return day !== 0 && day !== 6
	}
	picker2 = (d: Date | null): boolean => {
	  const day = (d || new Date()).getDay()
	  return day !== 0 && day !== 6
	}
  
	pickersd = (d: Date | null): boolean => {
	  const day = (d || new Date()).getDay()
	  return day !== 0 && day !== 6
	}
  
	pickered = (d: Date | null): boolean => {
	  const day = (d || new Date()).getDay()
	  return day !== 0 && day !== 6
	}
  
	startDate: string = ''
	endDate: string = ''
  
	placeForm: FormGroup
	searchorders: FormGroup
	viewprocessorders: FormGroup
	browsefiles: FormGroup
  
	loading = false
	submitted = false
	OcultarContenedor = false
	editarOrder = false
	startOrder = true
	valorContenedor: any
	orderID: any
	orderstatusEdit = 0
  
	@ViewChild(MatPaginator) paginator: MatPaginator
	@ViewChild(MatSort) sort: MatSort
  
	Toast = Swal.mixin({
	  toast: true,
	  position: 'center',
	  showConfirmButton: false,
	  timer: 3000,
	  timerProgressBar: false,
  
	  padding: '80px 20px 80px',
	  background: ' #ffffff29',
  
	  didOpen: toast => {
		Swal.showLoading()
		toast.addEventListener('mouseenter', Swal.stopTimer)
		toast.addEventListener('mouseleave', Swal.resumeTimer)
	  }
	})
	InventarioTable = false
	InventoryDatabase: ViewInventotyAvailableService | null
  
	dataInventory: ResponseInventoryAvailableNew2[] = []
	dataSource: MatTableDataSource<ResponseInventoryAvailableNew2>
	//#endregion
  
	constructor (
	  private formBuilder: FormBuilder,
	  private http: HttpClient,
	  public dialog: MatDialog,
	  private router: Router,
	  private authenticationService: AuthenticationService,
	  private spinner: NgxSpinnerService,
	  private _bottomSheet: MatBottomSheet
	) {
	  this.router.events
		.pipe(filter(event => event instanceof NavigationEnd))
		.subscribe(events => {
		  this.authenticationService.currentUser.subscribe(
			x => (this.currentUser = x)
		  )
		})
	  this.router.routeReuseStrategy.shouldReuseRoute = function () {
		return false
	  }
	  this.mySubscription = this.router.events.subscribe(event => {
		if (event instanceof NavigationEnd) {
		  // Trick the Router into believing it's last link wasn't previously loaded
		  this.router.navigated = true
		}
	  })
	  this.arrayDescripionRouting = []
	  this.PlaceOrderCustomer = []
	  this.PlaceOrderCustomer2 = []
	  this.PlaceOrderCustomer3 = []
	  this.PlaceOrderCustomer4 = []
	  this.arrayfiles = []
	  this.dataInventory=[];
	  this.PlaceOrderStatusDescripcion = []
	  this.PlaceOrder = []
	  this.ArrayDataTypeDocument = []
	  this.CarrirsSearch = []
	  this.ResponseViewProcessordersTableExportData = []
	  this.dataSourceSearch = new MatTableDataSource(this.data)
	  this.dataSourceSearchSO = new MatTableDataSource(this.dataSO)
	}
	//#region Funciones nativas
	ngOnInit (): void {
	  if (this.authenticationService.currentUserValue.company == 'LDT20') {
		this.placeForm = this.formBuilder.group({
		  inputPo: ['  '],
		  inputReferences: ['  '],
		  inputConfirmation: [''],
		  inputOSI: [''],
		  inputcono: [''],
		  dateShip: [new Date(new Date().setHours(0, 0, 0, 0))],
		  dateCancel: [new Date(new Date().setHours(0, 0, 0, 0))],
		  SelectCostumerPO: ['', Validators.required],
		  SelectStatusDescripcion: [395, Validators.required],
		  Routing: [49, Validators.required],
		  Billed: ['']
		})
	  } else {
		this.placeForm = this.formBuilder.group({
		  inputPo: ['', Validators.required],
		  inputReferences: [''],
		  inputConfirmation: [''],
		  inputOSI: [''],
		  inputcono: [''],
		  dateShip: [new Date(new Date().setHours(0, 0, 0, 0))],
		  dateCancel: [new Date(new Date().setHours(0, 0, 0, 0))],
		  SelectCostumerPO: ['', Validators.required],
		  SelectStatusDescripcion: ['', Validators.required],
		  Routing: ['', Validators.required],
		  Billed: ['']
		})
	  }
  
	  this.searchorders = this.formBuilder.group({
		SelectCostumerSO: [''],
		startDate: [''],
		endDate: [''],
		status:["2"]
	  })
  
	  /*   this.browsefiles = this.formBuilder.group({
		inputReferences: [''],
	  }); */
  
	  this.viewprocessorders = this.formBuilder.group({
		SelectCostumerView: [''],
		status:["1"]
	  })
  
	  this.OnSelectCostumer()
	  this.OnSelectStatusDescripcion()
	  this.OnSelectPlaceOrderViewDocumentType()
	  this.searchorders.controls.startDate.setValue(
		new Date(this.DefaultFechaInicio.value)
	  )
	  this.searchorders.controls.endDate.setValue(this.DefaultFechaFin.value)
	  var d = new Date()
	  var n = formatDate(d, 'yyyy-MM-dd', 'en-US')
  
	  var po = 'PO-' + n + '-' + this.makeid(5) + '-'
	  this.placeForm.controls.inputPo.setValue(' ')
	  this.OnClietData();
	}
	ngOnDestroy (): void {
	  if (this.mySubscription) {
		this.mySubscription.unsubscribe()
	  }
	}
	ngAfterViewInit () {
	  var element = document.getElementById('SubMenu')
	  element.style.display = 'none'
  
	  localStorage.setItem('header', '0')
	  this.dataSourceSearchSO.paginator = this.TableSearchPaginator
	  this.dataSourceSearchSO.sort = this.TableSearchSort
	  this.dataSourceSearch.paginator = this.TableViewProcessordersPaginator
	  this.dataSourceSearch.sort = this.TableViewProcessordersSort
	  this.OnSelectRouting()
  
	  try {
		if (this.authenticationService.currentUserValue.company == 'LDT20') {
		  this.isLDT = true
		} else {
		  this.isLDT = false
		}
	  } catch (error) {}
	  // this.serviceWms= new Client(environment.apiUrl2);
	  // this.RequestPalceO=new RequestPalceOrderEstatusDescripcion({
	  //   active:'1',
	  //   companyId:'1'
	  // })
	  // console.log(this.RequestPalceO)
  
	  //  this.serviceWms.searchCustomer(this.RequestPalceO).then((datos)=>{
	  //    console.log(datos)
	  //  })
	}
	//#endregion
  
	onKeySearchViewShpping (value) {
	  console.log(value)
	  this.PlaceOrderCustomer2 = this.searchviewshipping(value)
	}
	onKeySearchShpping (value) {
	  console.log(value)
	  this.PlaceOrderCustomer3 = this.searchviewshipping(value)
	}
	onKeySearchShppingPlaceOrder (value) {
	  console.log(value)
	  this.PlaceOrderCustomer4 = this.searchviewshipping(value)
	}
	searchviewshipping (value: string) {
	  let filter = value.toLowerCase()
	  return this.PlaceOrderCustomer.filter(option =>
		option.value.toLowerCase().includes(filter)
	  )
	}
  
	makeid (length) {
	  var result = ''
	  var characters =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	  var charactersLength = characters.length
	  for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength))
	  }
	  return result
	}
	OnChangeLoader () {
	  this.spinner.show()
  
	  setTimeout(() => {
		/** spinner ends after 5 seconds */
		this.spinner.hide()
	  }, 2000)
	}
	get f () {
	  return this.placeForm.controls
	}
  
	get so () {
	  return this.searchorders.controls
	}
  
	applyFilter (filterValue: String) {
	  this.dataSourceSearch.filter = filterValue.trim().toLowerCase()
	}
  
	onSubmit () {
	  if (this.placeForm.invalid) {
		return
	  }
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
  
	  var Request = {}
	  Request['tblCustomerID'] = Number(this.f.SelectCostumerPO.value)
	  Request['poNumber'] = String(this.f.inputPo.value) || ''
	  Request['refNumber'] = String(this.f.inputReferences.value) || ''
	  Request['shipDate'] = this.f.dateShip.value || null
	  Request['cancelShipDate'] = this.f.dateCancel.value || null
	  Request['notes'] = String(this.f.inputcono.value || '')
	  Request['status'] = '0'
	  Request['createdByUserID'] = Number(json.whId)
	  Request['comments'] = String(this.f.inputOSI.value || '')
	  Request['confirmation'] = String(this.f.inputConfirmation.value || '')
	  Request['tblCompanyStatusDescriptionID'] = Number(
		this.f.SelectStatusDescripcion.value || 0
	  )
	  Request['Routing'] = Number(this.f.Routing.value)
	  Request['Billed'] = Number(this.f.Billed.value)
	  Request['AllChargesAdded'] = Number(0)
	  this.http
		.post<any>(`${environment.apiUrl}/Shipping/PlaceOrder`, Request, {
		  headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Headers': '*',
			'Access-Control-Allow-Methods': '*',
			Authorization: 'Bearer ' + json.token
		  })
		})
		.subscribe((response: any) => {
		  console.log(response)
  
		  var resp = String(response.responses)
  
		  if (resp.includes('success')) {
			var spl = resp.replace('success-', '')
			localStorage.setItem('OrderData', JSON.stringify(Request))
			this.openDialog(spl, Request)
		  } else {
			Swal.fire('Place order', resp, 'info')
		  }
		})
	}
	public files: NgxFileDropEntry[] = []
  
	upload: number
	public dropped (files: NgxFileDropEntry[]) {
	  this.files = files
	  for (const droppedFile of files) {
		var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
		// Is it a file?
		if (droppedFile.fileEntry.isFile) {
		  const fileEntry = droppedFile.fileEntry as FileSystemFileEntry
		  fileEntry.file((file: File) => {
			// Here you can access the real file
			console.log(droppedFile.relativePath, file)
			// You could upload it like this:
			const formData = new FormData()
			formData.append('Adjunto', file) //adjunto
			formData.append('OrderId', String(this.idDocumentUpload)) //id de orden
			formData.append('CompanyId', json.companyIdWh) //id de compañia
			formData.append('docType', this.valorContenedor.value) //texto de select
			formData.append('docTypeId', this.valorContenedor.key) //valor de select
			formData.append('Estatus', '1') //checkbox publico
			// Headers
			this.http
			  .post<any>(
				`${environment.apiUrl}/Shipping/UploadFilePlaceOrder`,
				formData,
				{
				  headers: new HttpHeaders({
					'Access-Control-Allow-Origin': '*',
					'Access-Control-Allow-Headers': '*',
					'Access-Control-Allow-Methods': '*',
					Authorization: 'Bearer ' + json.token
				  }),
				  reportProgress: true,
				  observe: 'events'
				}
			  )
			  .subscribe((events: any) => {
				if (events.type == HttpEventType.UploadProgress) {
				  var upload = Math.round((events.loaded / events.total) * 100)
				  console.log(
					'Upload progress: ',
					Math.round((events.loaded / events.total) * 100) + '%'
				  )
				  this.upload = Math.round((events.loaded / events.total) * 100)
				  if (upload == 100) {
				  } else {
				  }
				} else if (events.type === HttpEventType.Response) {
				  console.log(events)
				  var data = String(events.body.responses)
				  if (data.includes('error')) {
					Swal.fire('File', 'Upload', 'error')
				  } else {
					Swal.fire('File', 'Upload success', 'success')
					var urls = data.replace('E:\\WMSUploadedUserFiles\\WMS', '')
					this.listfile = {
					  file: droppedFile.relativePath,
					  fileurl:
						'https://wmsdocs.3plfreightsoftware.com' +
						urls
						  .replace('\\', '/')
						  .replace('\\', '/')
						  .replace('\\', '/')
						  .replace('\\', '/')
						  .replace('\\', '/')
					}
					this.arrayfiles.push(this.listfile)
					//  this.OnChangeLoader();
					//    this.OnCancelFile();
					// this.router.navigate(['/perfil']);
					console.log(Response)
				  }
				}
			  })
		  })
		} else {
		  // It was a directory (empty directories are added, otherwise only files)
		  const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry
		  console.log(droppedFile.relativePath, fileEntry)
		}
	  }
	}
  
	public fileOver (event) {
	  console.log(event)
	}
  
	public fileLeave (event) {
	  console.log(event)
	}
	openDialog (datos: any, elementos: any): void {
	  this.DataFormulario = {
		tbId: String(datos),
		Company: '',
		Address: '',
		Address1: '',
		City: '',
		State: '',
		Zip: '',
		Phone: '',
		Fax: '',
		Cname: '',
		Cphone: '',
		Cemail: '',
  
		//Carrier instructions
		Account: '',
		BOL: '',
		Tracking: '',
		CarrierName: '',
		SCAC: '',
		Billing: '',
		ServiceType: '',
		Seal: '',
		Door: '',
		Trailer: '',
		PickupDate: '',
		loadnumber: '',
		Sealnumber: '',
		COD: '',
		warehouseInstructions: '',
		carrierInstructions: '',
  
		//Order Items
		Quantity: 1,
		Receiving: 1,
		Pallet: 1,
		Misc: '',
  
		// Order Charges
		Price: 1,
		Amount: 1,
		QuantityOC: 1,
		SelectSearch: [],
  
		SelectCapacity: '',
		PlaceOrderRegistro: JSON.parse(localStorage.getItem('OrderData'))
	  }
  
	  const dialogRef = this.dialog.open(DialogOverviewclientDialog, {
		width: '100vw',
		height: '100vw',
		data: this.DataFormulario,
		disableClose: true
	  })
  
	  dialogRef.afterClosed().subscribe(result => {
		localStorage.removeItem('OrderData')
  
		this.OnCancelEdit()
		console.log('The dialog was closed')
		this.Company = result
	  })
	}
  
	editDialog (datosDialog: any): void {
	  console.log('edit dialog', datosDialog)
	  this.DataFormulario = {
		tbId: String(datosDialog[0].tblOrderID),
		Company: datosDialog[0].CompanyName,
		Address: datosDialog[0].Address,
		Address1: datosDialog[0].Address1,
		City: datosDialog[0].City,
		State: datosDialog[0].State,
		Zip: datosDialog[0].ZipCode,
		Phone: datosDialog[0].Phone,
		Fax: datosDialog[0].Fax,
		Cname: datosDialog[0].ContactName,
		Cphone: datosDialog[0].ContactPhone,
		Cemail: datosDialog[0].ContactEmail,
  
		//Carrier instructions
		Account: datosDialog[0].carrier[0].AccountNumber,
		BOL: datosDialog[0].carrier[0].BOL,
		Tracking: datosDialog[0].carrier[0].TrackingNumber,
		CarrierName: datosDialog[0].carrier[0].Carrier,
		SCAC: datosDialog[0].carrier[0].SCAC,
		Billing: datosDialog[0].carrier[0].Billing,
		ServiceType: datosDialog[0].carrier[0].ServiceType,
		Seal: datosDialog[0].carrier[0].SealNumber,
		Door: datosDialog[0].carrier[0].DoorNumber,
		Trailer: datosDialog[0].carrier[0].TrailerNumber,
		PickupDate: datosDialog[0].carrier[0].PickupDate,
		loadnumber: datosDialog[0].carrier[0].LoadNumber,
		Sealnumber: datosDialog[0].carrier[0].SealNumber,
		COD: datosDialog[0].carrier[0].COD,
		warehouseInstructions: datosDialog[0].carrier[0].WarehouseInstructions,
		carrierInstructions: datosDialog[0].carrier[0].CarrierInstructions,
  
		//Order Items
		Quantity: 1,
		Receiving: 1,
		Pallet: 1,
		Misc: '',
  
		// Order Charges
		Price: 1,
		Amount: 1,
		QuantityOC: 1,
		SelectSearch: [],
  
		SelectCapacity: '',
		PlaceOrderRegistro: JSON.parse(localStorage.getItem('OrderData'))
	  }
  
	  const dialogRef = this.dialog.open(DialogOverviewclientDialog, {
		width: '100vw',
		height: '100vw',
		data: this.DataFormulario,
		disableClose: true
	  })
  
	  dialogRef.afterClosed().subscribe(result => {
		localStorage.removeItem('OrderData')
		this.OnCancelEdit()
		console.log('The dialog was closed')
		this.Company = result
	  })
	}
	OnChangeSearch () {
	  this.searchTable = true
	  this.SearchDatabase = new SearchTableViewProcessordersService(this.http)
	  // If the user changes the sort order, reset back to the first page.
	  this.OnChangeLoader()
	  merge()
		.pipe(
		  startWith({}),
		  switchMap(() => {
			this.isLoadingResultsView = true
			return this.SearchDatabase!.getSearchOrderShipping(
			  Number(this.viewprocessorders.controls.SelectCostumerView.value),
			  Number(this.viewprocessorders.controls.status.value),
			)
		  }),
		  map(data => {
			// Flip flag to show that loading has finished.
			this.isLoadingResultsView = false
			this.isRateLimitReachedView = false
			this.resultsLengthView = data.length
  
			return data
		  }),
		  catchError(() => {
			this.isLoadingResultsView = false
			// Catch if the GitHub API has reached its rate limit. Return empty data.
			this.isRateLimitReachedView = true
			return observableOf([])
		  })
		)
		.subscribe(datas => {
		  try {
			this.data = datas
			this.dataSourceSearch = new MatTableDataSource(this.data)
			this.dataSourceSearch.paginator = this.TableViewProcessordersPaginator
			this.dataSourceSearch.sort = this.TableViewProcessordersSort
		  } catch (error) {}
		})
	}
  
	OnChangeSearchOrder () {
	  this.searchTableView = true
	  this.SearchDatabaseSO = new SearchTableSearchOrdersService(this.http)
	  // If the user changes the sort order, reset back to the first page.
  
	  merge()
		.pipe(
		  startWith({}),
		  switchMap(() => {
			this.isLoadingResults = true
			return this.SearchDatabaseSO!.getShippingSearchOrders(
			  Number(this.so.SelectCostumerSO.value),
			  this.so.startDate.value,
			  this.so.endDate.value,
			  Number(  this.so.status.value)
			)
		  }),
		  map(data => {
			// Flip flag to show that loading has finished.
			this.isLoadingResults = false
			this.isRateLimitReached = false
			this.resultsLength = data.length
  
			return data
		  }),
		  catchError(() => {
			this.isLoadingResults = false
			// Catch if the GitHub API has reached its rate limit. Return empty data.
			this.isRateLimitReached = true
			return observableOf([])
		  })
		)
		.subscribe(datas => {
		  this.OnChangeLoader()
  
		  this.dataSO = datas
		  this.dataSourceSearchSO = new MatTableDataSource(this.dataSO)
		  this.dataSourceSearchSO.paginator = this.TableSearchPaginator
		  this.dataSourceSearchSO.sort = this.TableSearchSort
		})
	}
  
	OnSelectCostumer () {
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
  
	  var Request = {}
	  Request['companyId'] = json.companyIdWh
	  Request['active'] = '1'
  
	  this.http
		.post<any>(`${environment.apiUrl}/Shipping/PlaceOrderCustomer`, Request, {
		  headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Headers': '*',
			'Access-Control-Allow-Methods': '*',
			Authorization: 'Bearer ' + json.token
		  })
		})
		.subscribe((response: any) => {
		  this.PlaceOrderCustomer = response
		  this.PlaceOrderCustomer2 = response
		  this.PlaceOrderCustomer3 = response
		  this.PlaceOrderCustomer4 = response
		})
	}
	OnSelectRouting () {
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
  
	  var Request = {}
	  Request['companyId'] = Number(json.companyIdWh)
	  Request['active'] = Number('1')
  
	  this.http
		.post<any>(
		  `${environment.apiUrl}/Shipping/RoutingDescriptionsSelect`,
		  Request,
		  {
			headers: new HttpHeaders({
			  'Access-Control-Allow-Origin': '*',
			  'Access-Control-Allow-Headers': '*',
			  'Access-Control-Allow-Methods': '*',
			  Authorization: 'Bearer ' + json.token
			})
		  }
		)
		.subscribe((response: any) => {
		  this.arrayDescripionRouting = response
		})
	}
	OnSelectPlaceOrderViewDocumentType () {
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
  
	  var Request = {}
	  Request['companyId'] = json.companyIdWh
	  Request['active'] = '1'
  
	  this.http
		.post<any>(
		  `${environment.apiUrl}/Shipping/PlaceOrderViewDocumentType`,
		  Request,
		  {
			headers: new HttpHeaders({
			  'Access-Control-Allow-Origin': '*',
			  'Access-Control-Allow-Headers': '*',
			  'Access-Control-Allow-Methods': '*',
			  Authorization: 'Bearer ' + json.token
			})
		  }
		)
		.subscribe((response: any) => {
		  this.ArrayDataTypeDocument = response
		})
	}
  
	Oneditar (data: ResponseViewProcessordersTable) {
	  this.OnChangeLoader()
  
	  this.editarOrder = true
	  this.startOrder = false
	  this.placeForm.controls.inputPo.setValue(String(data.PONumber))
	  // this.placeForm.controls.inputPo.disable();
	  this.f.inputReferences.setValue(String(data.RefNumber))
	  this.f.SelectCostumerPO.setValue(
		Number(this.viewprocessorders.controls.SelectCostumerView.value)
	  )
	  this.f.SelectCostumerPO.disable()
  
	  if (data.CancelShipDate == null) {
	  } else {
		this.f.dateCancel.setValue(new Date(data.CancelShipDate))
	  }
	  if (data.ShipDate == null) {
	  } else {
		this.f.dateShip.setValue(new Date(data.ShipDate))
	  }
  
	  this.orderID = data.id
	  this.orderstatusEdit = Number(this.onSearchStatus(data.orderStatus)) || 0
  
	  try {
		this.f.inputConfirmation.setValue(String(data.Confirmation))
	  } catch (error) {}
	  try {
		this.f.inputOSI.setValue(String(data.Comments))
	  } catch (error) {}
	  try {
		this.f.inputcono.setValue(String(data.Notes))
	  } catch (error) {}
	  try {
		this.filterstatus = this.filterData(data.StatusDescription)
	  } catch (error) {}
	  try {
		this.f.SelectStatusDescripcion.setValue(this.filterstatus[0].key)
	  } catch (error) {}
	  try {
		this.f.Billed.setValue(data.Billed)
	  } catch (error) {}
	  try {
		this.f.Routing.setValue(data.Routing)
	  } catch (error) {}
	  this.tab1 = true
	  this.tab2 = false
	  this.tab3 = true
	  this.tab4 = true
  
	  this.indexTabs = new FormControl(1)
	}
  
	OnFile (data: ResponseViewProcessordersTable, tipo: Number) {
	  this.OnChangeLoader()
  
	  if (tipo == 1) {
		this.cancelFile = false
	  } else {
		this.cancelFile = true
	  }
	  this.idDocumentUpload = data.id
	  // this.browsefiles.controls.inputReferences.setValue(data.id);
  
	  this.tab1 = true
	  this.tab2 = true
	  this.tab3 = true
	  this.tab4 = false
  
	  this.indexTabs = new FormControl(3)
	}
  
	OnImprimir (data: ResponseViewProcessordersTable, tipo: any) {
	  var url = ''
	  if (tipo == 'Packing_Slip') {
		url +=
		  environment.apiComplement +
		  '/Views/Partner/shipping/packingslip.aspx?id=' +
		  data.id
	  } else if (tipo == 'Pick_Ticket') {
		if (this.authenticationService.currentUserValue.company == 'LDT20') {
		  url +=
			environment.apiComplement +
			'/Views/Partner/shipping/PickTicketList.aspx?stype=1&id=' +
			data.id
		} else {
		  url +=
			environment.apiComplement +
			'/Views/Partner/shipping/PickTicket.aspx?stype=1&id=' +
			data.id
		}
	  } else {
		url +=
		  environment.apiComplement +
		  '/Views/Partner/shipping/PickTicket.aspx?stype=0&id=' +
		  data.id
	  }
	  window.open(url)
	}
  
	OnPrint (data: ResponseViewProcessordersTable) {
	  console.log('data', data)
	  Swal.fire({
		title: '<strong>Print Documents</strong>',
  
		html:
		  '<a href= "' +
		  environment.apiComplement +
		  '/Views/Partner/shipping/packingslip.aspx?id=' +
		  data.id +
		  '" target="_blank">Packing Slp</a><br>' +
		  '<a href="http://news.ycombinator.com" target="_blank">Hacker News</a><br> ' +
		  '<a href="//sweetalert2.github.io" target="_blank">links</a><br> ',
		showCloseButton: true,
		focusConfirm: false,
		showConfirmButton: false
	  })
	}
  
	OneditarSearch (data: ResponseViewProcessordersTable) {
	  this.OnChangeLoader()
  
	  this.editarOrder = true
	  this.startOrder = false
	  this.placeForm.controls.inputPo.setValue(String(data.PONumber))
	  // this.placeForm.controls.inputPo.disable();
	  this.f.inputReferences.setValue(String(data.RefNumber))
	  this.f.SelectCostumerPO.setValue(
		Number(this.searchorders.controls.SelectCostumerSO.value)
	  )
	  this.f.SelectCostumerPO.disable()
  
	  try {
		if (data.CancelShipDate == null) {
		} else {
		  this.f.dateCancel.setValue(new Date(data.CancelShipDate))
		}
	  } catch (error) {}
	  try {
		if (data.ShipDate == null) {
		} else {
		  this.f.dateShip.setValue(new Date(data.ShipDate))
		}
	  } catch (error) {}
  
	  try {
		this.orderID = data.id
	  } catch (error) {}
	  try {
		this.orderstatusEdit = Number(this.onSearchStatus(data.orderStatus)) || 0
	  } catch (error) {}
	  try {
		this.f.inputConfirmation.setValue(String(data.Confirmation))
	  } catch (error) {}
	  try {
		this.f.inputOSI.setValue(String(data.Comments))
	  } catch (error) {}
	  try {
		this.f.inputcono.setValue(String(data.Notes))
	  } catch (error) {}
	  try {
		this.filterstatus = this.filterData(data.StatusDescription)
	  } catch (error) {}
	  try {
		this.f.SelectStatusDescripcion.setValue(this.filterstatus[0].key)
	  } catch (error) {}
	  try {
		this.f.Billed.setValue(data.Billed)
	  } catch (error) {}
	  try {
		this.f.Routing.setValue(data.Routing)
	  } catch (error) {}
	  this.tab1 = true
	  this.tab2 = false
	  this.tab3 = true
	  this.tab4 = true
	  this.indexTabs = new FormControl(1)
	}
	OnCancelEdit () {
	  this.OnChangeLoader()
  
	  this.editarOrder = false
	  this.startOrder = true
	  var d = new Date()
	  var n = formatDate(d, 'yyyy-MM-dd', 'en-US')
  
	  //var po = 'PO-' + n + '-' + this.makeid(5) + '-';
	  this.placeForm.controls.inputPo.setValue(' ')
	  this.placeForm.controls.inputPo.enable()
	  this.f.inputReferences.setValue('')
  
	 // this.f.SelectCostumerPO.setValue(null)
	  //this.f.SelectCostumerPO.enable()
	  this.f.dateCancel.setValue(new Date(new Date().setHours(0,0,0,0)))
	  this.f.dateShip.setValue(new Date(new Date().setHours(0,0,0,0)))
	  this.orderID = 0
	  this.orderstatusEdit = 0
	  this.f.inputConfirmation.setValue('')
	  this.f.inputOSI.setValue('')
	  this.f.inputcono.setValue('')
	  this.f.Billed.setValue(false)
	  this.f.Routing.setValue(null)
	  this.f.SelectStatusDescripcion.setValue(null)
	  if (this.authenticationService.currentUserValue.company == 'LDT20') {
		this.placeForm = this.formBuilder.group({
		  inputPo: [' '],
		  inputReferences: [' '],
		  inputConfirmation: [''],
		  inputOSI: [''],
		  inputcono: [''],
		  dateShip: [new Date(new Date().setHours(0, 0, 0, 0))],
		  dateCancel: [new Date(new Date().setHours(0, 0, 0, 0))],
		  SelectCostumerPO: ['', Validators.required],
		  SelectStatusDescripcion: [395, Validators.required],
		  Routing: [49, Validators.required],
		  Billed: ['']
		})
	  } else {
		this.placeForm = this.formBuilder.group({
		  inputPo: ['', Validators.required],
		  inputReferences: [''],
		  inputConfirmation: [''],
		  inputOSI: [''],
		  inputcono: [''],
		  dateShip: [new Date(new Date().setHours(0, 0, 0, 0))],
		  dateCancel: [new Date(new Date().setHours(0, 0, 0, 0))],
		  SelectCostumerPO: ['', Validators.required],
		  SelectStatusDescripcion: ['', Validators.required],
		  Routing: ['', Validators.required],
		  Billed: ['']
		})
	  }
	  this.tab1 = false
	  this.tab2 = false
	  this.tab3 = true
	  this.tab4 = true
	  this.OnClietData();
	  this.indexTabs = new FormControl(0)
	 
	  this.OnChangeSearch()
	//  this.OnChangeSearchOrder()
	}
	OnCancelFile () {
	  this.OnChangeLoader()
	  this.idDocumentUpload = 0
	  //this.browsefiles.controls.inputReferences.setValue(null);
  
	  this.tab1 = false
	  this.tab2 = false
	  this.tab3 = false
	  this.tab4 = true
  
	  this.indexTabs = new FormControl(0)
	}
	OnCancelFileSearch () {
	  this.OnChangeLoader()
	  this.idDocumentUpload = 0
	  // this.browsefiles.controls.inputReferences.setValue(null);
  
	  this.tab1 = false
	  this.tab2 = false
	  this.tab3 = false
	  this.tab4 = true
  
	  this.indexTabs = new FormControl(2)
	}
	EditOrder () {
	  if (this.placeForm.invalid) {
		return
	  }
	  this.spinner.show()
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
  
	  var Request = {}
	  Request['orderId'] = Number(this.orderID)
	  Request['tblCustomerID'] = Number(this.f.SelectCostumerPO.value)
	  Request['poNumber'] = String(this.f.inputPo.value) || ''
	  Request['refNumber'] = String(this.f.inputReferences.value) || ''
	  Request['shipDate'] = this.f.dateShip.value || null
	  Request['cancelShipDate'] = this.f.dateCancel.value || null
	  Request['notes'] = String(this.f.inputcono.value || '')
	  Request['status'] = String(this.orderstatusEdit)
	  Request['createdByUserID'] = Number(json.whId)
	  Request['comments'] = String(this.f.inputOSI.value || '')
	  Request['confirmation'] = String(this.f.inputConfirmation.value || '')
	  Request['tblCompanyStatusDescriptionID'] = Number(
		this.f.SelectStatusDescripcion.value || 0
	  )
	  Request['Routing'] = Number(this.f.Routing.value)
	  Request['Billed'] = Number(this.f.Billed.value)
  
	  ////////////////////
	  /*  var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario
	  console.log('json', json);
  
	  var Request = {};
	  Request['orderId'] = Number(this.orderID);
	  Request['tblCustomerID'] = this.f.SelectCostumerPO.value;
	  Request['poNumber'] = this.f.inputPo.value;
	  Request['refNumber'] = this.f.inputReferences.value;
	  Request['shipDate'] = this.f.dateShip.value;
	  Request['cancelShipDate'] = this.f.dateCancel.value;
	  Request['notes'] = this.f.inputcono.value;
	  Request['status'] = '0';
	  Request['createdByUserID'] = Number(json.whId);
	  Request['comments'] = this.f.inputOSI.value;
	  Request['confirmation'] = this.f.inputConfirmation.value;
	  Request['tblCompanyStatusDescriptionID'] = Number(
		this.f.SelectStatusDescripcion.value
	  ); */
  
	  this.http
		.post<any>(`${environment.apiUrl}/Shipping/PlaceOrderUpdate`, Request, {
		  headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Headers': '*',
			'Access-Control-Allow-Methods': '*',
			Authorization: 'Bearer ' + json.token
		  })
		})
		.subscribe((response: any) => {
		  this.spinner.hide()
		  this.spinner.show()
		  setTimeout(() => {
			try {
			  if (response.responses == 'success') {
				// this.OnChangeLoader()
  
				this.respEditOrder = response
				console.log(response)
				localStorage.setItem(
				  'customerEditOrderItems',
				  this.f.SelectCostumerPO.value
				)
  
				localStorage.setItem('OrderData', JSON.stringify(Request))
				this.spinner.hide()
				this.OnPlaceOrderViewShiptoCarriers()
			  }
			} catch (error) {
			  this.spinner.hide()
			}
		  }, 1200)
		})
	}
  
	OnPlaceOrderViewShiptoCarriers () {
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
	  console.log('json', json)
  
	  var Request = {}
  
	  console.log('order id placeOrderView', this.orderID)
	  Request['orderId'] = Number(this.orderID)
  
	  this.http
		.post<any>(
		  `${environment.apiUrl}/Shipping/PlaceOrderViewShiptoCarriers`,
		  Request,
		  {
			headers: new HttpHeaders({
			  'Access-Control-Allow-Origin': '*',
			  'Access-Control-Allow-Headers': '*',
			  'Access-Control-Allow-Methods': '*',
			  Authorization: 'Bearer ' + json.token
			})
		  }
		)
		.subscribe((response: any) => {
		  try {
			console.log('response edit dialog', String(response[0].tblOrderID))
			this.editDialog(response)
		  } catch (error) {
			this.openDialog(this.orderID, Request)
		  }
		})
	}
  
	Onevalidar (data: ResponseViewProcessordersTable, tipos: Number) {
	  console.log('validarID', JSON.stringify(data))
	  this.OnChangeLoader()
  
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
	  console.log('json', json)
  
	  var Request = {}
	  Request['companyId'] = Number(json.companyIdWh)
	  Request['orderId'] = Number(data.id)
	  Request['users'] = json.useremail
  
	  this.http
		.post<any>(
		  `${environment.apiUrl}/Shipping/PlaceOrderUpdateComplete`,
		  Request,
		  {
			headers: new HttpHeaders({
			  'Access-Control-Allow-Origin': '*',
			  'Access-Control-Allow-Headers': '*',
			  'Access-Control-Allow-Methods': '*',
			  Authorization: 'Bearer ' + json.token
			})
		  }
		)
		.subscribe((response: any) => {
		  if (response.responses == 'success') {
			this.spinner.show()
			this.respValidarOrder = response
			// this.OnChangeLoader()
  
			if (tipos == 1) {
			  this.OnChangeSearch()
			} else {
			  this.OnChangeSearchOrder()
			}
			this.spinner.hide()
		  } else {
			this.Toast.fire({
			  icon: 'error',
			  title: 'error'
			})
		  }
		})
	}
  
	Onecancelar (data: ResponseViewProcessordersTable, tipos: Number) {
	  console.log('cancelarID', JSON.stringify(data))
  
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
	  console.log('json', json)
  
	  var Request = {}
	  Request['companyId'] = Number(json.companyIdWh)
	  Request['orderId'] = Number(data.id)
	  Request['users'] = json.useremail
  
	  this.http
		.post<any>(`${environment.apiUrl}/Shipping/PlaceOrderDelete`, Request, {
		  headers: new HttpHeaders({
			'Access-Control-Allow-Origin': '*',
			'Access-Control-Allow-Headers': '*',
			'Access-Control-Allow-Methods': '*',
			Authorization: 'Bearer ' + json.token
		  })
		})
		.subscribe((response: any) => {
		  if (response.responses == 'success') {
			this.respCancelar = response
			this.OnChangeLoader()
  
			if (tipos == 1) {
			  this.OnChangeSearch()
			} else {
			  this.OnChangeSearchOrder()
			}
		  } else {
			this.Toast.fire({
			  icon: 'error',
			  title: 'error'
			})
		  }
		})
	}
  
	onedoctype (data: any) {
	  console.log('entra aqui')
	  console.log(data.value)
  
	  if (data.value != '' || data.value != null) {
		this.valorContenedor = data.value
		this.OcultarContenedor = true
  
		console.log(this.valorContenedor.key + '/' + this.valorContenedor.value)
	  }
	}
  
	OnSelectStatusDescripcion () {
	  var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
  
	  var Request = {}
	  Request['companyId'] = json.companyIdWh
	  Request['active'] = '1'
  
	  this.http
		.post<any>(
		  `${environment.apiUrl}/Shipping/PlaceOrderStatusDescripcion`,
		  Request,
		  {
			headers: new HttpHeaders({
			  'Access-Control-Allow-Origin': '*',
			  'Access-Control-Allow-Headers': '*',
			  'Access-Control-Allow-Methods': '*',
			  Authorization: 'Bearer ' + json.token
			})
		  }
		)
		.subscribe((response: any) => {
		  this.PlaceOrderStatusDescripcion = response
		})
	}
	filterData (locationName: string) {
	  return this.PlaceOrderStatusDescripcion.filter(object => {
		if (object['value'] == locationName) {
		  return object
		}
	  })
	}
  
	filterDataCustomerSearchOrder (locationName: string) {
	  return this.PlaceOrderCustomer.filter(object => {
		if (object['value'] == locationName) {
		  return object
		}
	  })
	}
	//LECTOR DE CODIGO DE BARRAS
	openDialogLectorGeneral (tipo: Number): void {
	  const dialogRef = this.dialog.open(CodeBarScannerComponent, {
		width: '300px',
		data: this.datosLector
	  })
  
	  dialogRef.afterClosed().subscribe(result => {
		if (tipo == 1) {
		  this.dataSourceSearch.filter = result.Resultado.trim().toLowerCase()
  
		  if (this.dataSourceSearch.paginator) {
			this.dataSourceSearch.paginator.firstPage()
		  }
		} else if (tipo == 2) {
		  this.dataSourceSearchSO.filter = result.Resultado.trim().toLowerCase()
  
		  if (this.dataSourceSearchSO.paginator) {
			this.dataSourceSearchSO.paginator.firstPage()
		  }
		}
	  })
	}
	//FILTRO DE TABLA DE CONFIRMACION DE PRODUCTO
	applyFilterTableSearch (event: Event) {
	  const filterValue = (event.target as HTMLInputElement).value
	  this.dataSourceSearchSO.filter = filterValue.trim().toLowerCase()
  
	  if (this.dataSourceSearchSO.paginator) {
		this.dataSourceSearchSO.paginator.firstPage()
	  }
	}
  
	openBottomSheet (data: any): void {
	  this.datosLector = {
		Resultado: '',
		modulo: data.id
	  }
	  this._bottomSheet.open(BottomSheetOverviewReceivingPDF, {
		data: this.datosLector
	  })
	}
	@ViewChild('exportExcel1') table: ElementRef
	exportAsExcel () {
	  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
		this.table.nativeElement
	  ) //converts a DOM TABLE element to a worksheet
	  const wb: XLSX.WorkBook = XLSX.utils.book_new()
	  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
  
	  /* save to file */
	  XLSX.writeFile(wb, 'SheetJS.xlsx')
	}
	@ViewChild('exportExcel2') table2: ElementRef
	exportAsExcel2 () {
	  const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
		this.table2.nativeElement
	  ) //converts a DOM TABLE element to a worksheet
	  const wb: XLSX.WorkBook = XLSX.utils.book_new()
	  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
  
	  /* save to file */
	  XLSX.writeFile(wb, 'SheetJS.xlsx')
	}
  
	openDialogImportShipping (): void {
	  const dialogRef = this.dialog.open(ImportShippingFaseOneComponent, {
		width: '100vw',
		height: '100vh',
		data: null
	  })
  
	  dialogRef.afterClosed().subscribe(result => {
		console.log('The dialog was closed')
	  })
	}
  
	onSearchStatus (label: any) {
	  if (label == 'Data Entry Not Completed') {
		return 0
	  } else if (label == 'Pending') {
		return 1
	  } else if (label == 'Warehouse Processing Order') {
		return 2
	  } else if (label == 'Order Completed') {
		return 3
	  } else if (label == 'Order Canceled') {
		return 4
	  } else if (label == 'Warehouse Completed Order') {
		return 5
	  } else {
		return 0
	  }
	}
  
	OpendialogExportShippingReport (): void {
		
let array=[];
let arrayE=[];
array=JSON.parse(localStorage.getItem('multipleCustomers'));
for (let index = 0; index <array.length; index++) {
	const element = array[index];
let json={
key:element.tblCustomerId,
value:element.customerName

};
arrayE.push(json);
	
}
	  const dialogRef = this.dialog.open(ExportShippingProductsComponent, {
		width: '80vw',
		height: '80vh',
		data: arrayE
	  })
  
	  dialogRef.afterClosed().subscribe(result => {})
	}
	OnChangeInventoryAvailable (datass: any) {
		this.InventarioTable = true
		this.InventoryDatabase = new ViewInventotyAvailableService(this.http)
		console.log('data')
		//this.inventorySearch=data;
		merge()
		  .pipe(
			startWith({}),
			switchMap(() => {
			  this.OnChangeLoader()
			  console.log('rrr')
			  return this.InventoryDatabase!.getRepoIssues2(
				String(datass),
				this.authenticationService.currentUserValue.token
			  )
			}),
			map(data => {
			  // Flip flag to show that loading has finished.
	
			  return data
			}),
			catchError(() => {
			  return observableOf([])
			})
		  )
		  .subscribe(datas => {
			this.dataInventory = datas
	
			this.dataSource = new MatTableDataSource(this.dataInventory)
	
			this.dataSource.sort = this.sortInven
			this.dataSource.paginator = this.paginatorInven
		  })
	  }
	
	  @ViewChild('exportExcel3') table3: ElementRef
	  exportAsExcel3 () {
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
		  this.dataInventory
		) //converts a DOM TABLE element to a worksheet
		const wb: XLSX.WorkBook = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
	
		/* save to file */
		XLSX.writeFile(wb, 'SheetJS.xlsx')
	  }
	  applyFilterInventario (event: Event) {
		const filterValue = (event.target as HTMLInputElement).value
		this.dataSource.filter = filterValue.trim().toLowerCase()
	
		if (this.dataSource.paginator) {
		  this.dataSource.paginator.firstPage()
		}
	  }
	  OnupdateStatusOrder (data: ResponseViewProcessordersTable, tipos: Number,status:any) {
		console.log('validarID', JSON.stringify(data))
		this.OnChangeLoader()
	
		var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
		console.log('json', json)
	
		var Request = {}
		Request['companyId'] = Number(json.companyIdWh)
		Request['orderId'] = Number(data.id)
		Request['users'] = json.useremail
		Request['status'] = String(status)
	
		this.http
		  .post<any>(
			`${environment.apiUrl}/Shipping/shippingOrderUpdateStatus`,
			Request,
			{
			  headers: new HttpHeaders({
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Headers': '*',
				'Access-Control-Allow-Methods': '*',
				Authorization: 'Bearer ' + json.token
			  })
			}
		  )
		  .subscribe((response: any) => {
			if (response.responses == 'success') {
			  this.spinner.show()
			  this.respValidarOrder = response
			  // this.OnChangeLoader()
	
			  if (tipos == 1) {
				this.OnChangeSearch()
			  } else {
				this.OnChangeSearchOrder()
			  }
			  this.spinner.hide()
			} else {
			  this.Toast.fire({
				icon: 'error',
				title: 'error'
			  })
			}
		  })
	  }
	  OnClietData () {
		var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
		this.placeForm.controls.SelectCostumerPO.setValue(Number(json.customerId))
		this.placeForm.controls.SelectCostumerPO.disable()
		this.searchorders.controls.SelectCostumerSO.setValue(
		  Number(json.customerId)
		)
		this.searchorders.controls.SelectCostumerSO.disable()
		this.viewprocessorders.controls.SelectCostumerView.setValue(
		  Number(json.customerId)
		)
		this.viewprocessorders.controls.SelectCostumerView.disable()
		this.OnChangeInventoryAvailable(Number(json.customerId))
	  }

  }
@Component({
  selector: 'dialog-overview-client-dialog',
  templateUrl: './client.modal.component.html',
  styleUrls: ['./client.modal.component.css']
})
export class DialogOverviewclientDialog implements OnInit, AfterViewInit {
  viewEditarMasiveP = false
  ArraySelectUpdateMasivePallets = []
  LabelProNumber = ''
  checkedAllCharges = false
  datosSelectChange: any
  tab1 = false
  tab2 = true
  tab3 = true
  tab4 = true
  buttonCancel = false
  indexTabs = new FormControl(0)
  placeordertwo = []
  SelectCostumerView = ''
  @ViewChild('TableViewProcessordersPaginator')
  TableViewProcessordersPaginator: MatPaginator
  @ViewChild('TableViewProcessordersSort') TableViewProcessordersSort: MatSort
  @ViewChild('TableViewProcessordersChangesSort')
  TableViewProcessordersChangesSort: MatSort
  @ViewChild('TableViewProcessordersChangesPaginator')
  TableViewProcessordersChangesPaginator: MatPaginator
  SearchDatabaseOrder: SearchTableOrderItemsService | null
  SearchDatabaseOrderCharges: SearchTableOrderChargerService | null
  datosOrder: ResponseOrderItemsTable[] = []
  datosOrderCharger: ResponseOrderChargerTable[] = []
  dataSourceSearchOrder: MatTableDataSource<ResponseOrderItemsTable>
  dataSourceOrderCharger: MatTableDataSource<ResponseOrderChargerTable>
  PlaceProducts = []
  PlaceProducts2 = []
  PlaceOrderCharges = []
  PlaceOrderCharges2 = []
  PlaceLabelOrderCharges = []
  totalPieces = ''
  totalPallets = ''
  totalChargers = ''
  valorProductos: any
  label1 = ''
  label2 = ''
  searchTable = false
  isLoadingResults = true
  isRateLimitReached = false
  resultsLength = 0
  isLoadingResultsOrderCharges = true
  isRateLimitReachedOrderCharges = false
  resultsLengthOrderCharges = 0
  searchTableOrderCharges = false
  fmorderchargers: FormGroup
  fmcarrier: FormGroup
  fmorderitems: FormGroup
  formShipto: FormGroup
  formBillto: FormGroup
  displayedColumnsOrderItems: string[] = [
    'ID',
    'ItemNumber',
    'Description',
    'miscnumber',
    'palletcount',
    'Location',
    'Quantity'
  ]

  displayedColumnsOrderCharges: string[] = [
    'ID',
    'tblOrderID',
    'tblInvoiceListID',
    'tblInvoiceListDescription',
    'ChargeDescription',
    'UnitPrice',
    'Quantity',
    'Total'
  ]

  // indexTabs: FormControl;

  Toast = Swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    background: ' #ffffff29',

    padding: '80px 20px 80px',

    didOpen: toast => {
      Swal.showLoading()
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
  dataItemsNew: any
  myControl = new FormControl()
  options: ResponseContact[]
  filteredOptions: Observable<ResponseContact[]>
  @ViewChild('autocompany') customerPayor: MatSelect
  @ViewChild('autocarrier') CrriersSearch: MatSelect
  CarrirsSearch = []
  TotalWeigth = 0
  ResponseListPallets: ResponseListPallets[]
  totalp = 0
  @ViewChild('ProdustSelect') ProdustSelect: MatSelect
  toppings = new FormControl('')

  ProNumberTable = ''
  datosEditar: ResponseOrderItemsTable
  viewEditar = false
  constructor (
    public dialogRef: MatDialogRef<DialogOverviewclientDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private _bottomSheet: MatBottomSheet,
    private auten: AuthenticationService,
    public dialog: MatDialog
  ) {
    this.placeordertwo = []
    this.PlaceProducts = []
    this.PlaceProducts2 = []
    this.PlaceOrderCharges = []
    this.PlaceOrderCharges2 = []
    this.PlaceLabelOrderCharges = []
    this.datosOrderCharger = []
    this.options = []
    this.CarrirsSearch = []
    this.ResponseListPallets = []
    this.dataSourceOrderCharger = new MatTableDataSource(this.datosOrderCharger)
    this.dataSourceSearchOrder = new MatTableDataSource(this.datosOrder)
    if (this.auten.currentUserValue.company == 'LDT20') {
      this.LabelProNumber = 'PRO#'
    } else {
      this.LabelProNumber = 'Misc#'
    }
    this.ArraySelectUpdateMasivePallets = []
  }
  ngOnInit (): void {
    localStorage.setItem(
      'customerEditOrderItems',
      this.data.PlaceOrderRegistro.tblCustomerID
    )

    this.formShipto = this.formBuilder.group({
      Company: [''],
      Address: [''],
      Address1: [''],
      City: [''],
      State: [''],
      Zip: [''],
      Phone: [''],
      Fax: [''],
      Cname: [''],
      Cphone: [''],
      Cemail: ['']
    })
    this.formBillto = this.formBuilder.group({
      Company: [''],
      Address: [''],
      Address1: [''],
      City: [''],
      State: [''],
      Zip: [''],
      Phone: [''],
      Fax: [''],
      Cname: [''],
      Cphone: [''],
      Cemail: ['']
    })

    this.fmcarrier = this.formBuilder.group({
      CarrierName: [''],
      PickupDate: [''],
      scac: [''],
      ServiceType: [''],
      Billing: [''],
      Account: [''],
      SelectCapacity: [''],
      cod: [''],
      loadnumber: [''],
      bol: [''],
      Tracking: [''],
      Trailer: [''],
      Sealnumber: [''],
      Door: [''],
      warehouseInstructions: [''],
      carrierInstructions: ['']
    })

    this.fmorderitems = this.formBuilder.group({
      PlaceProducts: [''],
      Quantity: [''],
      Misc: [''],
      Pallet: [''],
      pro: [''],
      PalletsMasive: ['']
    })
    this.fmorderchargers = this.formBuilder.group({
      PlaceOrderCharges: [''],
      Price: [''],
      QuantityOC: [''],
      Amount: ['']
    })
    this.OnSelectBillto(Number(this.data.tbId))
    this.OnSelectProducts(localStorage.getItem('customerEditOrderItems'))
    this.OnselectOrderChargers()
    this.OnlabelOrderChargers(Number(this.data.tbId))
    this.OnChangeOrderCharges(Number(this.data.tbId))
    this.OnChangeOrderItems(Number(this.data.tbId))
  }
  ngAfterViewInit () {
    this.dataSourceOrderCharger.sort = this.TableViewProcessordersChangesSort
    this.dataSourceOrderCharger.paginator = this.TableViewProcessordersChangesPaginator
    this.dataSourceSearchOrder.sort = this.TableViewProcessordersSort
    this.dataSourceSearchOrder.paginator = this.TableViewProcessordersPaginator
    this.fmorderchargers.controls.Price.setValue('1')
    this.fmorderchargers.controls.QuantityOC.setValue('1')
    this.fmorderchargers.controls.Amount.setValue('1')
    this.OnAllChargesView()
    try {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value.name)),
        map(name => (name ? this._filter(name) : this.options.slice()))
      )
    } catch (error) {}
    if (this.auten.currentUserValue.company == 'LDT20') {
      setTimeout(() => {
        this.OnDialogPlaceOrderTwo(this.data)
      }, 1200)
    }
  }

  OnDialogPlaceOrderTwo (datos: any) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var order = {}
    var Shipto = {}
    var Request = {}
    var tblContact = {}
    var tblCarrier = {}
	var tipo=""
    var ti=String(datos.PlaceOrderRegistro.status);

    if (ti=="0") {
      tipo="1"
    } else {
      tipo=String(datos.PlaceOrderRegistro.status)
    }

    console.log('imprimiendo datos ' + JSON.stringify(datos))

    order['tblCustomerID'] = datos.PlaceOrderRegistro.tblCustomerID
    order['poNumber'] = String(datos.PlaceOrderRegistro.poNumber||'')
    order['refNumber'] = String(datos.PlaceOrderRegistro.refNumber||'')
    order['shipDate'] = datos.PlaceOrderRegistro.shipDate||null
    order['cancelShipDate'] = datos.PlaceOrderRegistro.cancelShipDate||null
    order['notes'] = String(datos.PlaceOrderRegistro.notes||'')
    order['status'] = String(tipo||'1')
    order['createdByUserID'] = datos.PlaceOrderRegistro.createdByUserID
    order['comments'] = String(datos.PlaceOrderRegistro.comments||'')
    order['confirmation'] = String(datos.PlaceOrderRegistro.confirmation||'')
    order['tblCompanyStatusDescriptionID'] =
      datos.PlaceOrderRegistro.tblCompanyStatusDescriptionID

    Shipto['tblOrderID'] = Number(datos.tbId)
    Shipto['companyName'] = this.formShipto.controls.Company.value||'';
    Shipto['address'] = this.formShipto.controls.Address.value||'';
    Shipto['address1'] = this.formShipto.controls.Address1.value||'';
    Shipto['city'] = this.formShipto.controls.City.value||'';
    Shipto['state'] = this.formShipto.controls.State.value||'';
    Shipto['zipCode'] = this.formShipto.controls.Zip.value||'';
    Shipto['phone'] = this.formShipto.controls.Phone.value||'';
    Shipto['fax'] = this.formShipto.controls.Fax.value||'';
    Shipto['contactName'] = this.formShipto.controls.Cname.value||'';
    Shipto['contactEmail'] = this.formShipto.controls.Cemail.value||'';
    Shipto['contactPhone'] = this.formShipto.controls.Cphone.value||'';

    tblContact['tblCompanyID'] = Number(json.companyIdWh)
    tblContact['companyName'] = this.formShipto.controls.Company.value||'';
    tblContact['address'] = this.formShipto.controls.Address.value||'';
    tblContact['address1'] = this.formShipto.controls.Address1.value||'';
    tblContact['city'] = this.formShipto.controls.City.value||'';
    tblContact['state'] = this.formShipto.controls.State.value||'';
    tblContact['zipCode'] = this.formShipto.controls.Zip.value||'';
    tblContact['phone'] = this.formShipto.controls.Phone.value||'';
    tblContact['fax'] = this.formShipto.controls.Fax.value||'';
    tblContact['contactName'] = this.formShipto.controls.Cname.value||'';
    tblContact['contactEmail'] = this.formShipto.controls.Cemail.value||'';
    tblContact['contactPhone'] = this.formShipto.controls.Cphone.value||'';

    tblCarrier['tblOrderID'] = Number(datos.tbId)
    tblCarrier['carrier'] = this.fmcarrier.controls.CarrierName.value||'';
    tblCarrier['scac'] = this.fmcarrier.controls.scac.value
    tblCarrier['serviceType'] = this.fmcarrier.controls.ServiceType.value
    tblCarrier['billing'] = this.fmcarrier.controls.Billing.value
    tblCarrier['accountNumber'] = this.fmcarrier.controls.Account.value
    tblCarrier['capacity'] = this.fmcarrier.controls.SelectCapacity.value
    tblCarrier['cod'] = String(this.fmcarrier.controls.cod.value)
    tblCarrier['loadNumber'] = this.fmcarrier.controls.loadnumber.value
    tblCarrier['bol'] = this.fmcarrier.controls.bol.value
    tblCarrier['trackingNumber'] = this.fmcarrier.controls.Tracking.value
    tblCarrier['trailerNumber'] = this.fmcarrier.controls.Trailer.value
    tblCarrier['sealNumber'] = this.fmcarrier.controls.Sealnumber.value
    tblCarrier['pickupDate'] = this.fmcarrier.controls.PickupDate.value
    tblCarrier['doorNumber'] = this.fmcarrier.controls.Door.value
    tblCarrier[
      'warehouseInstructions'
    ] = this.fmcarrier.controls.warehouseInstructions.value
    tblCarrier[
      'carrierInstructions'
    ] = this.fmcarrier.controls.carrierInstructions.value
    Request['tblContact'] = tblContact
    Request['tblCarrier'] = tblCarrier
    Request['Shipto'] = Shipto
    Request['tbId'] = String(datos.tbId)
    Request['order'] = order

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/PlaceOrderTwo`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        this.placeordertwo = response
        console.log(response)
        this.onSaveBiillto(datos)
        this.OnNext(2)
      })

    // this.dialogRef.close();
  }

  onSaveBiillto (datos: any) {
    var Shipto = {}
    Shipto['tblOrderID'] = Number(datos.tbId)
    Shipto['companyName'] = this.formBillto.controls.Company.value
    Shipto['address'] = this.formBillto.controls.Address.value
    Shipto['address1'] = this.formBillto.controls.Address1.value
    Shipto['city'] = this.formBillto.controls.City.value
    Shipto['state'] = this.formBillto.controls.State.value
    Shipto['zipCode'] = this.formBillto.controls.Zip.value
    Shipto['phone'] = this.formBillto.controls.Phone.value
    Shipto['fax'] = this.formBillto.controls.Fax.value
    Shipto['contactName'] = this.formBillto.controls.Cname.value
    Shipto['contactEmail'] = this.formBillto.controls.Cemail.value
    Shipto['contactPhone'] = this.formBillto.controls.Cphone.value
    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/BillToShippingNewOrUpdata`,
        Shipto,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {})
  }

  OnSelectProducts (data: any) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}

    Request['customerId'] = Number(data) //datos.selCostumer;

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderViewProductsOrderItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.PlaceProducts = response
        this.PlaceProducts2 = response
      })
  }
  onKeyPlaceProducts (value) {
    console.log(value)
    if (value == '') {
      this.PlaceProducts2 = this.PlaceProducts
    } else {
      this.PlaceProducts2 = this.searchP(value)
    }
    //this.fmorderitems.controls.PlaceProducts.
    this.ProdustSelect.open()
  }

  searchP (value: string) {
    let filter = value.toLowerCase()

    return this.PlaceProducts.filter(object => {
      if (object["ItemNumber"].toLowerCase().includes(filter)) {
        return object
      }
    })
  }

  OnselectOrderChargers () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['companyid'] = json.companyIdWh
    Request['active'] = '1'

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderViewInvoiceList`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.PlaceOrderCharges = response
        this.PlaceOrderCharges2 = response
      })
  }
  onKeyPlaceOrderCharges (value) {
    console.log(value)
    this.PlaceOrderCharges2 = this.searchPlaceOrderCharges(value)
  }

  searchPlaceOrderCharges (value: string) {
    let filter = value.toLowerCase()
    return this.PlaceOrderCharges.filter(option =>
      option.value.toLowerCase().includes(filter)
    )
  }

  OnlabelOrderChargers (order: Number) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['orderid'] = order

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderViewSumQuantityAndPalletOrders`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.PlaceLabelOrderCharges = response
        this.totalPieces = response[0].PalletCount
        this.totalChargers = response[0].Quantity
      })
  }

  oneProducts (data: any) {
    this.valorProductos = data.value

    this.label2 = this.valorProductos.available
    this.label1 = this.valorProductos.Location

    this.OnListPallets(
      this.valorProductos.receivingID,
      this.valorProductos.available
    )
    try {
      this.fmorderitems.controls.Quantity.setValue(
        Number(this.valorProductos.available)
      )
    } catch (error) {}
  }

  OnChangeOrderItems (orden: Number) {
    this.searchTable = true
    this.SearchDatabaseOrder = new SearchTableOrderItemsService(this.http)
    // If the user changes the sort order, reset back to the first page.

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true
          return this.SearchDatabaseOrder!.getRepoIssues(Number(orden))
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false
          this.isRateLimitReached = false
          this.resultsLength = data.length

          return data
        }),
        catchError(() => {
          this.isLoadingResults = false
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true
          return observableOf([])
        })
      )
      .subscribe(datas => {
        this.datosOrder = datas
        this.dataSourceSearchOrder = new MatTableDataSource(this.datosOrder)

        this.dataSourceSearchOrder.sort = this.TableViewProcessordersSort
        this.dataSourceSearchOrder.paginator = this.TableViewProcessordersPaginator
        try {
          this.onViewWeigthPallet(orden)
        } catch (error) {}
      })
  }

  AddOrderItems () {}

  AddOrderCharger () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    this.datosSelectChange = this.fmorderchargers.controls.PlaceOrderCharges.value
    Request['tblOrderID'] = Number(this.data.tbId)

    Request['tblInvoiceListID'] = Number(this.datosSelectChange.key)
    Request['tblInvoiceListDescription'] = String(this.datosSelectChange.value)
    Request['chargeDescription'] = String(this.datosSelectChange.value)
    Request['unitPrice'] = String(this.fmorderchargers.controls.Price.value)
    Request['quantity'] = String(this.fmorderchargers.controls.QuantityOC.value)
    Request['total'] = String(this.fmorderchargers.controls.Amount.value)

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderNewOrderChanges`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.OnChangeOrderCharges(Number(this.data.tbId))
        this.OnlabelOrderChargers(Number(this.data.tbId))
        this.OnChangeOrderItems(Number(this.data.tbId))
        this.fmorderchargers.controls.Price.setValue('1')
        this.fmorderchargers.controls.QuantityOC.setValue('1')
        this.fmorderchargers.controls.Amount.setValue('1')
      })
  }

  OnChangeOrderCharges (order: Number) {
    this.searchTableOrderCharges = true
    this.SearchDatabaseOrderCharges = new SearchTableOrderChargerService(
      this.http
    )

    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResultsOrderCharges = true
          return this.SearchDatabaseOrderCharges!.getRepoIssues(Number(order))
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResultsOrderCharges = false
          this.isRateLimitReachedOrderCharges = false
          this.resultsLengthOrderCharges = data.length

          return data
        }),
        catchError(() => {
          this.isLoadingResultsOrderCharges = false
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReachedOrderCharges = true
          return observableOf([])
        })
      )
      .subscribe(datas => {
        this.datosOrderCharger = datas
        this.dataSourceOrderCharger = new MatTableDataSource(
          this.datosOrderCharger
        )

        this.dataSourceOrderCharger.sort = this.TableViewProcessordersChangesSort
        this.dataSourceOrderCharger.paginator = this.TableViewProcessordersChangesPaginator
      })
  }

  applyFilter (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSourceSearchOrder.filter = filterValue.trim().toLowerCase()

    if (this.dataSourceSearchOrder.paginator) {
      this.dataSourceSearchOrder.paginator.firstPage()
    }
  }

  applyFilterOrderCharges (event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSourceOrderCharger.filter = filterValue.trim().toLowerCase()

    if (this.dataSourceOrderCharger.paginator) {
      this.dataSourceOrderCharger.paginator.firstPage()
    }
  }

  onNoClick (): void {
    localStorage.removeItem('customerEditOrderItems')
    this.dialogRef.close()
  }

  //metodo registro order items
  OnNewOrderItems () {
    this.dataItemsNew = this.fmorderitems.controls.PlaceProducts.value
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
    if (
      Number(this.fmorderitems.controls.Quantity.value) > Number(this.label2)
    ) {
      return
    }
    var Request = {}
    Request['tblOrderID'] = Number(this.data.tbId)
    Request['tblProductID'] = Number(this.dataItemsNew.id)
    Request['quantity'] = Number(this.fmorderitems.controls.Quantity.value || 1)
    Request['status'] = '0'
    Request['miscNumber'] = String(this.fmorderitems.controls.Misc.value)
    Request['tblReceivingProductsItemsID'] = Number(
      this.dataItemsNew.receivingID
    )
    Request['palletCount'] = Number(this.fmorderitems.controls.Pallet.value)
    Request['tblReceivingProductsLocationID'] = Number(
      this.dataItemsNew.locationID
    )

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderNewOrderItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.fmorderitems.controls.Quantity.setValue('1')
        this.fmorderitems.controls.Misc.setValue('')
        this.PlaceLabelOrderCharges = []
        this.totalPieces = ''
        this.totalChargers = ''
        this.valorProductos = ''

        this.label2 = ''
        this.label1 = ''

        this.OnSelectProducts(localStorage.getItem('customerEditOrderItems'))
        this.OnChangeOrderCharges(Number(this.data.tbId))
        this.OnlabelOrderChargers(Number(this.data.tbId))
        this.OnChangeOrderItems(Number(this.data.tbId))
      })
  }

  OnNewOrderItemsMasivo () {
    for (let index = 0; index < this.toppings.value.length; index++) {
      const element = this.toppings.value[index]
      this.dataItemsNew = this.fmorderitems.controls.PlaceProducts.value
      var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
      var Request = {}
      Request['tblOrderID'] = Number(this.data.tbId)
      Request['tblProductID'] = Number(element.tblProductID)
      Request['quantity'] = Number(element.quantity)
      Request['status'] = '0'
      Request['miscNumber'] = String(this.fmorderitems.controls.Misc.value)
      Request['tblReceivingProductsItemsID'] = Number(
        element.tblReceivingProductsItemsID
      )
      Request['palletCount'] = Number(element.palletCount)
      Request['tblReceivingProductsLocationID'] = Number(
        element.tblReceivingProductsLocationID
      )

      this.http
        .post<any>(
          `${environment.apiUrl}/Shipping/PlaceOrderNewOrderItems`,
          Request,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization: 'Bearer ' + json.token
            })
          }
        )
        .subscribe((response: any) => {})
    }

    setTimeout(() => {
      this.ResponseListPallets = []
      try {
        this.toppings.reset()
      } catch (error) {}
      this.totalp = 0
      this.fmorderitems.controls.Quantity.setValue('1')
      this.fmorderitems.controls.Misc.setValue('')
      this.PlaceLabelOrderCharges = []
      this.totalPieces = ''
      this.totalChargers = ''
      this.valorProductos = ''

      this.label2 = ''
      this.label1 = ''

      this.OnSelectProducts(localStorage.getItem('customerEditOrderItems'))
      this.OnChangeOrderCharges(Number(this.data.tbId))
      this.OnlabelOrderChargers(Number(this.data.tbId))
      this.OnChangeOrderItems(Number(this.data.tbId))
    }, 1300)
  }

  OnListPallets (tblReceivingProductsItemsID: number, quantity: number) {
    var Request = {
      quantity: quantity,
      tblReceivingProductsItemsID: tblReceivingProductsItemsID
    }

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/RequestListPallets`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + this.auten.currentUserValue.token
        })
      })
      .subscribe((response: ResponseListPallets[]) => {
        console.log(response)
        this.ResponseListPallets = response
        try {
          this.totalp = this.ResponseListPallets.length
        } catch (error) {
          this.totalp = 0
        }
      })
  }
  //metodo registro order items
  OnAllChargesView () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['id'] = Number(this.data.tbId)

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/ShippingAllChargesSelect`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.checkedAllCharges = response[0].AllChargesAdded
        console.log(response)
      })
  }
  OnAllChargesUpdate (data: any) {
    console.log(data)
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}
    Request['OrderId'] = Number(this.data.tbId)

    Request['active'] = Number(data.checked)

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/ShippingAllChargesUpdate`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.OnAllChargesView()
      })
  }
  Onedeletemodal (data: ResponseViewProcessordersTable) {
    console.log('deleteid', JSON.stringify(data))

    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
    console.log('json', json)

    var Request = {}

    Request['orderId'] = Number(data.id)

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/DeleteOrderItems`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        if (response.responses == 'success') {
          this.OnSelectProducts(localStorage.getItem('customerEditOrderItems'))
          this.OnselectOrderChargers()
          this.OnlabelOrderChargers(Number(this.data.tbId))
          this.OnChangeOrderCharges(Number(this.data.tbId))
          this.OnChangeOrderItems(Number(this.data.tbId))
          //this.OnChangeLoader();
        } else {
          this.Toast.fire({
            icon: 'error',
            title: 'error'
          })
        }
      })
  }
  OnEditarProNumbermodal (data: ResponseOrderItemsTable) {
    this.datosEditar = data
    this.viewEditar = true
    this.ProNumberTable = data.miscnumber
    this.fmorderitems.controls.pro.setValue(String(data.miscnumber))
  }

  OnSaveEditarPro () {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
    console.log('json', json)

    var Request = {}

    Request['OrderItemsId'] = Number(this.datosEditar.id)
    Request['Pro'] = String(this.fmorderitems.controls.pro.value)
    console.log('json', Request)
    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/ProNumberOrderItems`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        this.OnChangeOrderItems(Number(this.data.tbId))
        this.OnClearEditarPro()
      })
  }

  OnClearEditarPro () {
    this.ProNumberTable = ''
    this.viewEditar = false
    this.viewEditarMasiveP = false
    this.fmorderitems.controls.pro.setValue('')
    this.fmorderitems.controls.PalletsMasive.setValue(null)
  }

  OnDeleteOrderChanges (data: ResponseOrderChargerTable) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
    console.log('json', json)

    var Request = {}

    Request['orderId'] = Number(data.id)

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/DeleteOrderItemsChanges`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        if (response.responses == 'success') {
          this.OnSelectProducts(localStorage.getItem('customerEditOrderItems'))
          this.OnselectOrderChargers()
          this.OnlabelOrderChargers(Number(this.data.tbId))
          this.OnChangeOrderCharges(Number(this.data.tbId))
          this.OnChangeOrderItems(Number(this.data.tbId))
        } else {
          this.Toast.fire({
            icon: 'error',
            title: 'error'
          })
        }
      })
  }
  OnChangeSelectbusqueda (data: any) {
    try {
      this.formShipto.controls.Company.setValue(data.value.CompanyName)
    } catch (error) {}
    try {
      this.formShipto.controls.Address.setValue(data.value.Address)
    } catch (error) {}
    try {
      this.formShipto.controls.Address1.setValue(data.value.Address1)
    } catch (error) {}
    try {
      this.formShipto.controls.City.setValue(data.value.City)
    } catch (error) {}
    try {
      this.formShipto.controls.State.setValue(data.value.State)
    } catch (error) {}
    try {
      this.formShipto.controls.Zip.setValue(data.value.ZipCode)
    } catch (error) {}
    try {
      this.formShipto.controls.Cemail.setValue(data.value.ContactEmail)
    } catch (error) {}
    try {
      this.formShipto.controls.Phone.setValue(data.value.Phone)
    } catch (error) {}
    try {
      this.formShipto.controls.Fax.setValue(data.value.Fax)
    } catch (error) {}
    try {
      this.formShipto.controls.Cname.setValue(data.value.ContactName)
    } catch (error) {}
    try {
      this.formShipto.controls.Cemail.setValue(data.value.ContactEmail)
    } catch (error) {}
    try {
      this.formShipto.controls.Cphone.setValue(data.value.ContactPhone)
    } catch (error) {}
  }

  buscaCompany (fCompanyName: String) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}

    Request['companyid'] = Number(json.companyIdWh)
    Request['textSearch'] = fCompanyName

    this.http
      .post<any>(
        `${environment.apiUrl}/Shipping/PlaceOrderTwoViewContacts`,
        Request,
        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: ResponseContact[]) => {
        this.options = response
        console.log('respuesta ', response)

        if (response != null) {
          console.log('no es null')
        }
        this.customerPayor.open()
      })
  }

  buscaCarrier (fCarrierName: String) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    var Request = {}

    Request['companyid'] = Number(json.companyIdWh)
    Request['textSearch'] = fCarrierName

    this.http
      .post<any>(`${environment.apiUrl}/Shipping/CarriersSearchCode`, Request, {
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Methods': '*',
          Authorization: 'Bearer ' + json.token
        })
      })
      .subscribe((response: any) => {
        console.log('respuesta ', response)
        this.CarrirsSearch = response
        if (response != null) {
          console.log('no es null')
          this.CrriersSearch.open()
        }
      })
  }
  OnChangeCarriersSearch (data: any) {
    this.fmcarrier.controls.CarrierName.setValue(data.value.CarrierName)
    this.fmcarrier.controls.scac.setValue(data.value.SCACCode)
  }

  OnNext (tabs: Number) {
    if (tabs == 1) {
      this.indexTabs.setValue(1)
      this.tab1 = true
      this.tab2 = false
    } else if (tabs == 2) {
      this.indexTabs.setValue(2)
      this.tab1 = true
      this.tab2 = true
      this.tab3 = false
      this.tab4 = false
      this.buttonCancel = true
    } else if (tabs == 0) {
      this.indexTabs.setValue(0)
      this.tab1 = false
      this.tab2 = true
      this.tab3 = true
      this.tab4 = true
      this.buttonCancel = true
    } else if (tabs == 3) {
      this.indexTabs.setValue(1)
      this.tab1 = false
      this.tab2 = true
      this.tab3 = true
      this.tab4 = true
      this.buttonCancel = true
    } else if (tabs == 4) {
      this.indexTabs.setValue(3)
      this.tab1 = true
      this.tab2 = true
      this.tab3 = true
      this.tab4 = false
      this.buttonCancel = true
    }
  }

  OnMultiplicarCharges () {
    this.fmorderchargers.controls.Amount.setValue(
      Number(this.fmorderchargers.controls.Price.value) *
        Number(this.fmorderchargers.controls.QuantityOC.value)
    )
  }

  displayFn (user: ResponseContact): string {
    return user && user.CompanyName ? user.CompanyName : ''
  }

  private _filter (name: string): ResponseContact[] {
    const filterValue = name.toLowerCase()

    return this.options.filter(option =>
      option.CompanyName.toLowerCase().includes(filterValue)
    )
  }

  onViewWeigthPallet (OrderId: any) {
    this.http
      .get<any>(
        `${
          environment.apiUrl
        }/Shipping/PlaceOrderweightpalletssum?OrderId=${Number(OrderId)}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.TotalWeigth = response[0].weight_pllets
        } catch (error) {}
      })
  }

  OnGroupByItems (group: string) {
    var grouped = this.groupBy(this.datosOrder, pet => pet.ItemNumber)
    console.log(grouped.get(group))
    this.ArraySelectUpdateMasivePallets = grouped.get(group)
    this.viewEditarMasiveP = true
    this.viewEditar = true
  }
  groupBy (list, keyGetter) {
    const map = new Map()
    list.forEach(item => {
      const key = keyGetter(item)
      const collection = map.get(key)
      if (!collection) {
        map.set(key, [item])
      } else {
        collection.push(item)
      }
    })
    return map
  }

  OnSaveUpdateByPallets () {
    var arr = this.fmorderitems.controls.PalletsMasive.value
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index]
      //console.log(element)
      var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario
      // console.log('json', json);

      var Request = {}

      Request['OrderItemsId'] = Number(element.id)
      Request['Pro'] = String(this.fmorderitems.controls.pro.value)
      console.log('json', Request)
      this.http
        .post<any>(
          `${environment.apiUrl}/Shipping/ProNumberOrderItems`,
          Request,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization: 'Bearer ' + json.token
            })
          }
        )
        .subscribe((response: any) => {})
    }

    setTimeout(() => {
      this.OnChangeOrderItems(Number(this.data.tbId))
      this.OnClearEditarPro()
    }, 1200)
  }

  openDialog (data: string): void {
    var grouped = this.groupBy(this.datosOrder, pet => pet.miscnumber)

    const dialogRef = this.dialog.open(PdfBillOfLadingComponent, {
      width: '100vw',
      height: '100vh',
      data: {
        items: grouped.get(data),
        shipto: this.formShipto.value,
        billto: this.formBillto.value,
        carrier: this.fmcarrier.value,
        orderData: JSON.parse(localStorage.getItem('OrderData')),
		order:this.data.tbId
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed')
    })
  }

  OnSelectBillto (order: any) {
    var json = JSON.parse(localStorage.getItem('currentUser')) //json con datos de usuario

    this.http
      .get<any>(
        `${
          environment.apiUrl
        }/Shipping/ShippingBillToByOrderId?OrderId=${Number(order)}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + json.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.formBillto.controls.Company.setValue(response[0].CompanyName)
          this.formBillto.controls.Address.setValue(response[0].Address)
          this.formBillto.controls.Address1.setValue(response[0].Address1)
          this.formBillto.controls.City.setValue(response[0].City)
          this.formBillto.controls.State.setValue(response[0].State)
          this.formBillto.controls.Zip.setValue(response[0].ZipCode)
          this.formBillto.controls.Phone.setValue(response[0].Phone)
          this.formBillto.controls.Fax.setValue(response[0].Fax)
          this.formBillto.controls.Cname.setValue(response[0].ContactName)
          this.formBillto.controls.Cemail.setValue(response[0].ContactPhone)
          this.formBillto.controls.Cphone.setValue(response[0].ContactEmail)
        } catch (error) {
          var custo = JSON.parse(localStorage.getItem('OrderData'))
          this.OnChangeCustomerDefaultBillTo(custo.tblCustomerID)
        }
      })
  }

  OnChangeCustomerDefaultBillTo (CustomerID: number) {
    this.http
      .get<any>(
        `${
          environment.apiUrl
        }/Administracion/selectCustomeInfo?CustomerID=${Number(CustomerID)}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization: 'Bearer ' + this.auten.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        try {
          this.formBillto.controls.Company.setValue(response[0].Company_Name)
          this.formBillto.controls.Address.setValue(response[0].Company_Address)
          this.formBillto.controls.Address1.setValue(
            response[0].Company_Address1
          )
          this.formBillto.controls.City.setValue(response[0].Company_City)
          this.formBillto.controls.State.setValue(response[0].Company_State)
          this.formBillto.controls.Zip.setValue(response[0].Company_Zip)
          this.formBillto.controls.Phone.setValue(response[0].Company_Phone)
          this.formBillto.controls.Fax.setValue(response[0].Company_Fax)
          this.formBillto.controls.Cname.setValue(response[0].ContactName)
          this.formBillto.controls.Cemail.setValue(response[0].ContactPhone)
          this.formBillto.controls.Cphone.setValue(response[0].ContactEmail)
        } catch (error) {}
      })
  }
}
